import React from "react";
import { Users, Target, Rocket, Settings, Calendar } from "lucide-react";
import { COACHING } from "../mock";
import Reveal from "./ui/Reveal";

const ICONS = [Users, Target, Settings, Rocket, Calendar];

export default function Coaching() {
  return (
    <section className="py-24 lg:py-36 bg-[#0c0c0c] border-y border-white/5">
      <div className="container-max">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <Reveal variant="fade-left" className="lg:col-span-5">
            <span className="section-label">Coaching One‑to‑One</span>
            <h2 className="font-display text-4xl lg:text-6xl leading-[1] text-white mt-6">
              Costruiamo<br />
              <span className="italic font-light text-white/60">insieme</span><br />
              il tuo sistema.
            </h2>
            <p className="text-white/70 text-lg mt-8 max-w-md leading-relaxed">{COACHING.desc}</p>
            <div className="mt-10 grid grid-cols-3 gap-4">
              <div className="border border-white/10 rounded-xl p-4">
                <div className="font-display text-3xl" style={{ color: "#6b8bff" }}>3</div>
                <div className="text-white/50 text-xs mt-1">sessioni</div>
              </div>
              <div className="border border-white/10 rounded-xl p-4">
                <div className="font-display text-3xl" style={{ color: "#6b8bff" }}>6h</div>
                <div className="text-white/50 text-xs mt-1">di lavoro insieme</div>
              </div>
              <div className="border border-white/10 rounded-xl p-4">
                <div className="font-display text-3xl" style={{ color: "#6b8bff" }}>1:1</div>
                <div className="text-white/50 text-xs mt-1">con un esperto</div>
              </div>
            </div>
          </Reveal>

          <Reveal variant="fade-right" delay={150} className="lg:col-span-7">
            <ul className="space-y-3">
              {COACHING.items.map((it, i) => {
                const Icon = ICONS[i] || Users;
                return (
                  <li
                    key={i}
                    className="group bg-card border border-white/10 rounded-2xl p-6 hover-lift flex items-center gap-5"
                  >
                    <div className="font-mono-label text-white/30 text-lg">0{i + 1}</div>
                    <div className="w-11 h-11 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center flex-shrink-0 group-hover:bg-lime group-hover:border-transparent transition-all">
                      <Icon size={18} className="text-white group-hover:text-black transition-colors" />
                    </div>
                    <span className="text-white/90 text-base lg:text-lg">{it}</span>
                  </li>
                );
              })}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
